// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase config object - your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyCDDAhiIzuhswSowJJyrSkivcJZRSSjNXQ",
  authDomain: "meetingcardapp.firebaseapp.com",
  projectId: "meetingcardapp",
  storageBucket: "meetingcardapp.firebasestorage.app",
  messagingSenderId: "1014603944277",
  appId: "1:1014603944277:web:1557bff16ab33658e61fdc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with specific database ID
export const db = getFirestore(app, 'amritvelasadhana');

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

export default app;
